import JustValidate from 'just-validate';
import {
	addressRules,
	birthdateRules,
	emailRules,
	getErrorContainer,
	nameRules,
} from '../../assets/scripts/utils/validationRules';

class MyData {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('.my-data');

		if (!this.container) {
			return;
		}

		this._initValidation();
	}

	_initValidation() {
		const form = document.querySelector('.my-data__form');

		if (!form || form.inited) {
			return;
		}

		const inputs = {
			surname: form.querySelector('#my-data-surname'),
			name: form.querySelector('#my-data-name'),
			tel: form.querySelector('#my-data-tel'),
			email: form.querySelector('#my-data-email'),
			birthdate: form.querySelector('#my-data-birthdate'),
			country: form.querySelector('#my-data-country'),
			city: form.querySelector('#my-data-settlement'),
			street: form.querySelector('#my-data-street'),
			house: form.querySelector('#my-data-house'),
			apartment: form.querySelector('#my-data-appartment'),
			intercom: form.querySelector('#my-data-intercom'),
		};
		const submitButton = form.querySelector('.popup__submit');

		const validator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});

		form.validator = validator;

		validator
			.addField(inputs.surname, nameRules, {
				errorsContainer: getErrorContainer(inputs.surname),
			})
			.addField(inputs.name, nameRules, {
				errorsContainer: getErrorContainer(inputs.name),
			})
			.addField(
				inputs.tel,
				[
					{
						rule: 'required',
						errorMessage: 'Обязательное поле',
					},
					{
						validator: (value, context) => {
							return (
								value.replace(/\D/g, '').length >
								context[3].elem.placeholder.replace(/\D/g, '').length - 1
							);
						},
						errorMessage: 'Неверный формат',
					},
				],
				{
					errorsContainer: getErrorContainer(inputs.tel),
				},
			)
			.addField(inputs.email, emailRules, {
				errorsContainer: getErrorContainer(inputs.email),
			})
			.addField(inputs.birthdate, birthdateRules, {
				errorsContainer: getErrorContainer(inputs.birthdate),
			})
			.addField(
				inputs.country,
				[
					{
						rule: 'required',
						errorMessage: 'Обязательное поле',
					},
					...addressRules,
				],
				{
					errorsContainer: getErrorContainer(inputs.country),
				},
			)
			.addField(
				inputs.city,
				[
					{
						rule: 'required',
						errorMessage: 'Обязательное поле',
					},
					...addressRules,
				],
				{
					errorsContainer: getErrorContainer(inputs.city),
				},
			)
			.addField(
				inputs.street,
				[
					{
						rule: 'required',
						errorMessage: 'Обязательное поле',
					},
					...addressRules,
				],
				{
					errorsContainer: getErrorContainer(inputs.street),
				},
			)
			.addField(
				inputs.house,
				[
					{
						rule: 'required',
						errorMessage: 'Обязательное поле',
					},
					...addressRules,
				],
				{
					errorsContainer: getErrorContainer(inputs.house),
				},
			)
			.addField(inputs.apartment, addressRules, {
				errorsContainer: getErrorContainer(inputs.apartment),
			})
			.addField(
				inputs.intercom,
				[
					{
						rule: 'customRegexp',
						value: /^[0-9A-Za-z*#]+$/,
						errorMessage: 'Неверный формат',
					},
				],
				{
					errorsContainer: getErrorContainer(inputs.intercom),
				},
			)
			.onValidate(({ isValid }) => {
				submitButton.disabled = !isValid;
			});

		submitButton.disabled = !validator.isValid;
		form.inited = true;
	}
}

export default new MyData();
